import type { JSX } from 'solid-js';
import { splitProps } from 'solid-js';

type Props = JSX.HTMLAttributes<HTMLParagraphElement>;

export function ErrorText(props: Props) {
  const [local, rest] = splitProps(props, ['children']);
  return (
    <p class="text-bad text-sm" role="alert" {...rest}>
      {local.children}
    </p>
  );
}
